import tw, { styled } from 'twin.macro'
import { OptimizedImage } from '~/components/molecules/OptimizedImage'
import Link from 'next/link'

export const Screen = styled.div`
  ${tw`flex flex-col`}
`

export const PressReleaseDate = styled.time`
  ${tw`text-base text-gray-300 tracking-widest`}
`

export const PressTopHeader = styled.h2`
  ${tw`text-5xl pt-2 pb-10`}
`

export const ReadMoreNextLink = styled(Link)`
  ${tw`no-underline`}
`

export const ReadMoreLink = styled.div`
  ${tw`flex gap-2 pt-6 items-center text-turquoise-500 dark:text-emerald-500 uppercase`}
`

export const PressReleasesSection = styled.section`
  ${tw`mt-24 grid grid-cols-1 lg:grid-cols-2 lg:grid-rows-[minmax(100vh, min-content)] w-full`}
`

export const PressReleasesList = styled.div`
  ${tw`px-6 lg:px-10 xl:px-16 pb-16 dark:text-white`}

  > h3 {
    ${tw`text-4xl pt-8 lg:pt-0`}
  }

  > ul {
    ${tw`pt-6 list-none`}

    > li {
      ${tw`pt-8 tracking-widest text-xl`}

      > a {
        ${tw`text-white no-underline hover:text-turquoise-500 dark:hover:text-emerald-500`}
      }
    }
  }
`

export const PressInquiresNote = styled.div`
  ${tw`pt-6`}

  > a {
    ${tw`no-underline text-turquoise-500 dark:text-emerald-500`}
  }
`

export const PressReleaseSectionImageWrapper = styled.div`
  ${tw`[grid-column:1_/_span_1] [grid-row:1_/_span_1] lg:[grid-column:2_/_span_1]`}
  ${tw`w-full h-[40rem] lg:h-full relative`}
  ${tw`lg:sticky lg:[top:72px] lg:h-[calc(100vh - 72px)]`}
`

export const PressReleaseSectionImage = styled(OptimizedImage)`
  ${tw`bg-gold-500 dark:bg-taupe-500`}
`
